import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-panel-cmi',
  templateUrl: './payment-panel-cmi.component.html',
})
export class PaymentPanelCmiComponent {}
